import React from "react";

interface Props {
  big?: boolean;
  pathFill?: string;
}
export default function Icon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.big ? "74" : "48"}
      height={props.big ? "74" : "48"}
      viewBox="0 0 48 48"
      fill="none"
    >
      <g clipPath="url(#clip0_13554_40155)">
        <path
          d="M39.1472 39.1446C31.3316 46.9433 18.6761 46.9433 10.8605 39.1446L10.5776 38.8618C2.96137 30.9344 3.17069 18.3439 11.0443 10.674C18.9236 3.00402 31.5141 3.12848 39.2363 10.9526C46.9601 18.7781 46.9219 31.37 39.1472 39.1446ZM13.9324 36.5592C16.9655 39.5278 21.0537 41.1699 25.2975 41.1243C29.5413 41.0787 33.5932 39.3491 36.5618 36.316C39.5304 33.2828 41.1725 29.1947 41.1269 24.9509C41.0813 20.707 39.3517 16.6551 36.3186 13.6865L25.0038 25.0012L13.6891 13.6865C10.6932 16.69 9.01069 20.759 9.01069 25.0012C9.01069 29.2435 10.6932 33.3125 13.6891 36.316L13.9324 36.5592Z"
          fill="#262C34"
        />
      </g>
      <defs>
        <clipPath id="clip0_13554_40155">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(-3.28418 25) rotate(-45)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
